module.exports = __webpack_public_path__ + "public/images/bts_hero_image_6.9669801860a3bc89c1789fbb7fa51336.webp";